const CO = {
  countryConfig: {
    accountHolderDocNumber: {
      label: "bankDetails.accountHolderDocNumber",
      placeholder: "bankDetails.documentCedulaPlaceholder",
      visible: true,
      required: true,
    },
    accountNumber: {
      visible: true,
      label: "bankDetails.accountNumber",
      required: true,
    },
    accountTypeBankDetails: {
      label: "bankDetails.accountTypeBankDetails",
      visible: true,
      required: true,
    },
    bankName: {
      visible: true,
      label: "bankDetails.bankName",
      required: true,
    },
    IBAN: {
      visible: false,
      required: false,
    },
    swift: {
      label: "bankDetails.swift",
      visible: true,
      required: true,
    },
    bankAddress: {
      visible: false,
      required: false,
    },
  },
};
export { CO };
